import styled from 'styled-components';

export const NewsListerWrapper = styled.div`
	margin: 5em auto;
	width: 80%;
`;
